import React from 'react';
import Tasks from './Tasks';

export default function TasksModal({ open, onClose, initialFileForCreate, onConsumedInitialFile }) {
  if (!open) return null;

  return (
    <div
      data-modal="tasks"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100001,
        display: 'flex',
        background: 'rgba(4,10,13,0.72)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
      }}
      onClick={onClose}
    >
      <div style={{ display: 'flex', width: '100%', minWidth: 0 }} onClick={e => e.stopPropagation()}>
        <Tasks
          modal
          onClose={onClose}
          initialFileForCreate={initialFileForCreate}
          onConsumedInitialFile={onConsumedInitialFile}
        />
      </div>
    </div>
  );
}
